export default __webpack_public_path__ + "static/remote_w.0f7e36f62efd3667dd21a31ac821ccaa.png";